// source: key_storage.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var elixirpb_pb = require('./elixirpb_pb.js');
goog.object.extend(proto, elixirpb_pb);
var key_pb = require('./key_pb.js');
goog.object.extend(proto, key_pb);
goog.exportSymbol('proto.PVKeys.KSSData', null, global);
goog.exportSymbol('proto.PVKeys.PublicUserKey', null, global);
goog.exportSymbol('proto.PVKeys.UserKey', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PVKeys.UserKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PVKeys.UserKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PVKeys.UserKey.displayName = 'proto.PVKeys.UserKey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PVKeys.PublicUserKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PVKeys.PublicUserKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PVKeys.PublicUserKey.displayName = 'proto.PVKeys.PublicUserKey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PVKeys.KSSData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PVKeys.KSSData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PVKeys.KSSData.displayName = 'proto.PVKeys.KSSData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PVKeys.UserKey.prototype.toObject = function(opt_includeInstance) {
  return proto.PVKeys.UserKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PVKeys.UserKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PVKeys.UserKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    protocolVersion: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    keyVersion: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    privateKey: (f = msg.getPrivateKey()) && key_pb.Key.toObject(includeInstance, f),
    signingKey: (f = msg.getSigningKey()) && key_pb.Key.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PVKeys.UserKey}
 */
proto.PVKeys.UserKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PVKeys.UserKey;
  return proto.PVKeys.UserKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PVKeys.UserKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PVKeys.UserKey}
 */
proto.PVKeys.UserKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setProtocolVersion(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setKeyVersion(value);
      break;
    case 3:
      var value = new key_pb.Key;
      reader.readMessage(value,key_pb.Key.deserializeBinaryFromReader);
      msg.setPrivateKey(value);
      break;
    case 4:
      var value = new key_pb.Key;
      reader.readMessage(value,key_pb.Key.deserializeBinaryFromReader);
      msg.setSigningKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PVKeys.UserKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PVKeys.UserKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PVKeys.UserKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PVKeys.UserKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getPrivateKey();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      key_pb.Key.serializeBinaryToWriter
    );
  }
  f = message.getSigningKey();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      key_pb.Key.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 protocol_version = 1;
 * @return {number}
 */
proto.PVKeys.UserKey.prototype.getProtocolVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.PVKeys.UserKey} returns this
 */
proto.PVKeys.UserKey.prototype.setProtocolVersion = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PVKeys.UserKey} returns this
 */
proto.PVKeys.UserKey.prototype.clearProtocolVersion = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.UserKey.prototype.hasProtocolVersion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 key_version = 2;
 * @return {number}
 */
proto.PVKeys.UserKey.prototype.getKeyVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.PVKeys.UserKey} returns this
 */
proto.PVKeys.UserKey.prototype.setKeyVersion = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PVKeys.UserKey} returns this
 */
proto.PVKeys.UserKey.prototype.clearKeyVersion = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.UserKey.prototype.hasKeyVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Key private_key = 3;
 * @return {?proto.PVKeys.Key}
 */
proto.PVKeys.UserKey.prototype.getPrivateKey = function() {
  return /** @type{?proto.PVKeys.Key} */ (
    jspb.Message.getWrapperField(this, key_pb.Key, 3));
};


/**
 * @param {?proto.PVKeys.Key|undefined} value
 * @return {!proto.PVKeys.UserKey} returns this
*/
proto.PVKeys.UserKey.prototype.setPrivateKey = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PVKeys.UserKey} returns this
 */
proto.PVKeys.UserKey.prototype.clearPrivateKey = function() {
  return this.setPrivateKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.UserKey.prototype.hasPrivateKey = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Key signing_key = 4;
 * @return {?proto.PVKeys.Key}
 */
proto.PVKeys.UserKey.prototype.getSigningKey = function() {
  return /** @type{?proto.PVKeys.Key} */ (
    jspb.Message.getWrapperField(this, key_pb.Key, 4));
};


/**
 * @param {?proto.PVKeys.Key|undefined} value
 * @return {!proto.PVKeys.UserKey} returns this
*/
proto.PVKeys.UserKey.prototype.setSigningKey = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PVKeys.UserKey} returns this
 */
proto.PVKeys.UserKey.prototype.clearSigningKey = function() {
  return this.setSigningKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.UserKey.prototype.hasSigningKey = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PVKeys.PublicUserKey.prototype.toObject = function(opt_includeInstance) {
  return proto.PVKeys.PublicUserKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PVKeys.PublicUserKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PVKeys.PublicUserKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    protocolVersion: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    keyVersion: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    publicKey: (f = msg.getPublicKey()) && key_pb.Key.toObject(includeInstance, f),
    verifyKey: (f = msg.getVerifyKey()) && key_pb.Key.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PVKeys.PublicUserKey}
 */
proto.PVKeys.PublicUserKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PVKeys.PublicUserKey;
  return proto.PVKeys.PublicUserKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PVKeys.PublicUserKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PVKeys.PublicUserKey}
 */
proto.PVKeys.PublicUserKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setProtocolVersion(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setKeyVersion(value);
      break;
    case 3:
      var value = new key_pb.Key;
      reader.readMessage(value,key_pb.Key.deserializeBinaryFromReader);
      msg.setPublicKey(value);
      break;
    case 4:
      var value = new key_pb.Key;
      reader.readMessage(value,key_pb.Key.deserializeBinaryFromReader);
      msg.setVerifyKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PVKeys.PublicUserKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PVKeys.PublicUserKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PVKeys.PublicUserKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PVKeys.PublicUserKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getPublicKey();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      key_pb.Key.serializeBinaryToWriter
    );
  }
  f = message.getVerifyKey();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      key_pb.Key.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 protocol_version = 1;
 * @return {number}
 */
proto.PVKeys.PublicUserKey.prototype.getProtocolVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.PVKeys.PublicUserKey} returns this
 */
proto.PVKeys.PublicUserKey.prototype.setProtocolVersion = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PVKeys.PublicUserKey} returns this
 */
proto.PVKeys.PublicUserKey.prototype.clearProtocolVersion = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.PublicUserKey.prototype.hasProtocolVersion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 key_version = 2;
 * @return {number}
 */
proto.PVKeys.PublicUserKey.prototype.getKeyVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.PVKeys.PublicUserKey} returns this
 */
proto.PVKeys.PublicUserKey.prototype.setKeyVersion = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PVKeys.PublicUserKey} returns this
 */
proto.PVKeys.PublicUserKey.prototype.clearKeyVersion = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.PublicUserKey.prototype.hasKeyVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Key public_key = 3;
 * @return {?proto.PVKeys.Key}
 */
proto.PVKeys.PublicUserKey.prototype.getPublicKey = function() {
  return /** @type{?proto.PVKeys.Key} */ (
    jspb.Message.getWrapperField(this, key_pb.Key, 3));
};


/**
 * @param {?proto.PVKeys.Key|undefined} value
 * @return {!proto.PVKeys.PublicUserKey} returns this
*/
proto.PVKeys.PublicUserKey.prototype.setPublicKey = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PVKeys.PublicUserKey} returns this
 */
proto.PVKeys.PublicUserKey.prototype.clearPublicKey = function() {
  return this.setPublicKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.PublicUserKey.prototype.hasPublicKey = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Key verify_key = 4;
 * @return {?proto.PVKeys.Key}
 */
proto.PVKeys.PublicUserKey.prototype.getVerifyKey = function() {
  return /** @type{?proto.PVKeys.Key} */ (
    jspb.Message.getWrapperField(this, key_pb.Key, 4));
};


/**
 * @param {?proto.PVKeys.Key|undefined} value
 * @return {!proto.PVKeys.PublicUserKey} returns this
*/
proto.PVKeys.PublicUserKey.prototype.setVerifyKey = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PVKeys.PublicUserKey} returns this
 */
proto.PVKeys.PublicUserKey.prototype.clearVerifyKey = function() {
  return this.setVerifyKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.PublicUserKey.prototype.hasVerifyKey = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PVKeys.KSSData.prototype.toObject = function(opt_includeInstance) {
  return proto.PVKeys.KSSData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PVKeys.KSSData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PVKeys.KSSData.toObject = function(includeInstance, msg) {
  var f, obj = {
    protocolVersion: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    userKey: (f = msg.getUserKey()) && proto.PVKeys.UserKey.toObject(includeInstance, f),
    deviceKey: (f = msg.getDeviceKey()) && proto.PVKeys.UserKey.toObject(includeInstance, f),
    deviceId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PVKeys.KSSData}
 */
proto.PVKeys.KSSData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PVKeys.KSSData;
  return proto.PVKeys.KSSData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PVKeys.KSSData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PVKeys.KSSData}
 */
proto.PVKeys.KSSData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setProtocolVersion(value);
      break;
    case 2:
      var value = new proto.PVKeys.UserKey;
      reader.readMessage(value,proto.PVKeys.UserKey.deserializeBinaryFromReader);
      msg.setUserKey(value);
      break;
    case 3:
      var value = new proto.PVKeys.UserKey;
      reader.readMessage(value,proto.PVKeys.UserKey.deserializeBinaryFromReader);
      msg.setDeviceKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PVKeys.KSSData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PVKeys.KSSData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PVKeys.KSSData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PVKeys.KSSData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getUserKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.PVKeys.UserKey.serializeBinaryToWriter
    );
  }
  f = message.getDeviceKey();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.PVKeys.UserKey.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint64 protocol_version = 1;
 * @return {number}
 */
proto.PVKeys.KSSData.prototype.getProtocolVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.PVKeys.KSSData} returns this
 */
proto.PVKeys.KSSData.prototype.setProtocolVersion = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PVKeys.KSSData} returns this
 */
proto.PVKeys.KSSData.prototype.clearProtocolVersion = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.KSSData.prototype.hasProtocolVersion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserKey user_key = 2;
 * @return {?proto.PVKeys.UserKey}
 */
proto.PVKeys.KSSData.prototype.getUserKey = function() {
  return /** @type{?proto.PVKeys.UserKey} */ (
    jspb.Message.getWrapperField(this, proto.PVKeys.UserKey, 2));
};


/**
 * @param {?proto.PVKeys.UserKey|undefined} value
 * @return {!proto.PVKeys.KSSData} returns this
*/
proto.PVKeys.KSSData.prototype.setUserKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PVKeys.KSSData} returns this
 */
proto.PVKeys.KSSData.prototype.clearUserKey = function() {
  return this.setUserKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.KSSData.prototype.hasUserKey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UserKey device_key = 3;
 * @return {?proto.PVKeys.UserKey}
 */
proto.PVKeys.KSSData.prototype.getDeviceKey = function() {
  return /** @type{?proto.PVKeys.UserKey} */ (
    jspb.Message.getWrapperField(this, proto.PVKeys.UserKey, 3));
};


/**
 * @param {?proto.PVKeys.UserKey|undefined} value
 * @return {!proto.PVKeys.KSSData} returns this
*/
proto.PVKeys.KSSData.prototype.setDeviceKey = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PVKeys.KSSData} returns this
 */
proto.PVKeys.KSSData.prototype.clearDeviceKey = function() {
  return this.setDeviceKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.KSSData.prototype.hasDeviceKey = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string device_id = 4;
 * @return {string}
 */
proto.PVKeys.KSSData.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PVKeys.KSSData} returns this
 */
proto.PVKeys.KSSData.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PVKeys.KSSData} returns this
 */
proto.PVKeys.KSSData.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PVKeys.KSSData.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.PVKeys);
